import ReactApexChart from 'react-apexcharts';

export default function SeriesChart({ options, series, height, width }) {
  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      height={height ?? 350}
      width={width ?? '100%'}
    />
  );
}
